import { Component, computed, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Question } from '../models';

@Component({
    selector: 'fgai-themes',
    imports: [CommonModule],
    templateUrl: './themes.html',
    styleUrl: './themes.scss',
})
export class Themes {
    /**
     * one-based question page number
     */
    active = input(1);
    questions = input<Question[]>([]);
    activeTheme = computed(() => {
        const active = this.active();
        const questions = this.questions();

        if (active <= questions.length) {
            return questions[active - 1].theme;
        }

        return null;
    });

    themes = computed(() => {
        const groups: {
            name: string,
            questions: (Question)[]
        }[] = [];

        const questions = this.questions();
        for (const question of questions) {
            const last = groups.length - 1;
            if (groups.length === 0 || groups[last].name !== question.theme) {
                groups.push({
                    name: question.theme,
                    questions: [question]
                });
            } else {
                groups[last].questions.push(question);
            }
        }

        return {
            length: questions.length,
            groups
        }
    });
}
